const webLinkTargets = {
  MODAL: 'modal',
  NEW_WINDOW: 'new-window',
  SAME_WINDOW: 'same-window',
} as const;

export default webLinkTargets;
